import { render, staticRenderFns } from "./ManagerServiceDetail.vue?vue&type=template&id=2b2b1a68&"
import script from "./ManagerServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ManagerServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManagerServiceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports